// RSO-change CAS-208 change direction on change language

const RTL_LANGUAGES = ["fa", "ar"];

export function applyRTLStyles(language) {
  const htmlElement = document.documentElement;
  // htmlElement.removeAttribute("dir");
  if (RTL_LANGUAGES.includes(language)) {
    htmlElement.setAttribute("dir", "rtl");
  } else {
    htmlElement.setAttribute("dir", "ltr");
  }
}
